import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { LottieComponent } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

// components
import { ButtonComponent } from './components/button/button.component';
import { InputComponent } from './components/input/input.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SelectComponent } from './components/select/select.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { ModalComponent } from './components/modal/modal.component';
import { IconsComponent } from './components/icons/icons.component';
import { TransactionTotalComponent } from './components/transaction-total/transaction-total.component';
import { HotToastModule } from '@ngneat/hot-toast';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { PaymentCardComponent } from './components/payment-card/payment-card.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { SliderComponent } from './components/slider/slider.component';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { OverlayComponent } from './components/overlay/overlay.component';
import { TimerComponent } from './components/timer/timer.component';
import { ToastComponent } from './components/toast/toast.component';
import { PhoneComponent } from './components/phone/phone.component';
import { TextButtonComponent } from './components/text-button/text-button.component';
import { InformerComponent } from './components/informer/informer.component';

// directives
import { ControlEditorDirective } from './directives/control-editor.directive';
import { ReplacePipe } from './pipes/replace.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { MonthPipe } from './pipes/month.pipe';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxTippyModule,
    HotToastModule,
    LottieComponent,
  ],
  declarations: [
    ButtonComponent,
    InputComponent,
    SpinnerComponent,
    SelectComponent,
    TextareaComponent,
    StepperComponent,
    AvatarComponent,
    ToggleComponent,
    ModalComponent,
    IconsComponent,
    TimerComponent,
    TransactionTotalComponent,
    ControlEditorDirective,
    ReplacePipe,
    SortPipe,
    ToastComponent,
    PhoneComponent,
    DatepickerComponent,
    DropdownComponent,
    TextButtonComponent,
    PaymentCardComponent,
    TimelineComponent,
    CheckboxComponent,
    SliderComponent,
    OverlayComponent,
    WarningModalComponent,
    InformerComponent,
    MonthPipe,
  ],
  exports: [
    NgxTippyModule,
    ButtonComponent,
    InputComponent,
    SpinnerComponent,
    SelectComponent,
    TextareaComponent,
    StepperComponent,
    AvatarComponent,
    ToggleComponent,
    TimerComponent,
    ModalComponent,
    IconsComponent,
    TransactionTotalComponent,
    ControlEditorDirective,
    ReplacePipe,
    SortPipe,
    ToastComponent,
    PhoneComponent,
    DatepickerComponent,
    DropdownComponent,
    TextButtonComponent,
    PaymentCardComponent,
    TimelineComponent,
    CheckboxComponent,
    SliderComponent,
    OverlayComponent,
    WarningModalComponent,
    InformerComponent,
    MonthPipe,
    PaymentCardComponent,
  ],
})
export class ComponentsModule {}
